import { Swiper } from "swiper/bundle";
import selectors from '../../scripts/constants';
export default class Carousel {
  constructor() {
    this.carousel = document.querySelectorAll(".evp_carousel__swiper");
  }
  init() {
    // console.log('carousel', this.carousel);
    this.carousel.forEach((elem, i) => {
      const maxSlidesPerView = elem.getAttribute('data-max-slides-per-view') || 3;

      new Swiper(elem, {
        slidesPerView: 1.2,
        slidesPerGroup: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: selectors.carouselPagination,
          type: "bullets",
          clickable: true,
        },
        navigation: {
          prevEl: elem.parentElement.querySelector(selectors.carouselPrev),
          nextEl: elem.parentElement.querySelector(selectors.carouselNext),
        },
        breakpoints: {
          576: {
            slidesPerView: Math.min(2, maxSlidesPerView),
          },
          992: {
            slidesPerView: Math.min(3, maxSlidesPerView),
          },
        },
      });
    });
  }
}